import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import SendFeedbackWebController from '../controller/SendFeedbackWebController';

export class SendFeedbackWebComponent extends BaseWebComponentElement {
  constructor() {
    super();

    this.initialSetup({
      controllerConstructor: SendFeedbackWebController,
    });
  }
}
